import React, { useEffect } from "react";
import Back from "../../../assets/back.svg";
import "../Style.css";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";


function CreateModelProgress({ title, indexActualPage, PrevData}) {
    const navigate = useNavigate()
    const [completedStep, setCompletedStep] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);

    const stepLabel = ["Basic information", "Bank statement analysis", "Credit report analysis", "Wrap Up", "Preview and confirm"]

    useEffect(()=>{
        if( currentStep === stepLabel.length){
            setCompletedStep(true)
        }else{
            setCurrentStep(indexActualPage);
        }

    }, [])

    const handlePreviousPage=()=>{
        navigate(-1, {state: PrevData});
    }

    return (
        <div className="mt-5 mx-6">
            <span>
                <button onClick={handlePreviousPage}>
                    <img src={Back} alt="Back Arrow" />
                </button>
            </span>
            <div className="flex flex-col items-center justify-center">

                <div className="mb-5 flex gap-x-10 relative">
                    {stepLabel?.map((label, index) => (
                        <div key={index}
                            className={`items-center flex flex-col stepper-item                           
                        `} >

                            <div className={`text-center 
                                 ${(label === 'Credit report analysis' || label === 'Preview and confirm') && "text-down circle"}
                                 ${label === 'Wrap Up'&& "text-down"}
                                 ${label === 'Basic information'&& "text-down"}
                            `}>{label}</div>
                            <div
                                className={`border bg-white border-solid border-1 rounded-full w-3 h-3 z-50
                                ${currentStep === index + 1 && "border-blue-600"} 
                                ${(index + 1 < currentStep) && "complete"} 
                                ${(index + 1 > currentStep) && "border-gray-400"} 
                                `}
                             
                            ></div>  
                            {/* <p>indice {index + 1}</p>           */}
                        </div>                       
                    ))}

                    {/* <p>Current {currentStep}</p> */}
                </div>                 

                <h1 className="xl:text-xl md:text-lg sm:text-base font-medium">{title}</h1>
            </div>
        </div>
    )

}

export default CreateModelProgress;




           {/*} <div className="flex flex-col items-center justify-center">
                {/* <div className="mb-5 container">  */}
                {/* space between flex gap-10 stepper-item `${className}` 
                    <div className="mb-5 flex gap-x-10  relative stepper-item">
                   
                        <div className="items-center flex flex-col">  
                            <div className="text-center text-down ">Basic information</div>
                                <div className={`border bg-white border-solid border-1 border-blue-700 rounded-full w-3 h-3 z-50 circle
                                            ${location.pathname === '/CreateModelStep1' || location.pathname === '/CreateModelStep2'  ? 'border-blue-700' : 'bg-blue-600'}
                                            `}
                                ></div>                             
                        </div>
                        <div className="items-center flex flex-col">
                            <div className="text-center ">Bank statement analysis</div>
                                <div className={`border bg-white border-solid border-1 rounded-full w-3 h-3 z-50 border-gray-400                            
                                            ${location.pathname === '/CreateModelStep3_0' ? 'border-blue-600' : null}
                                            ${location.pathname === '/CreateModelStep3' ? 'border-blue-600 bg-blue-600' : null}
                                            ${location.pathname === '/CreateModelStep4' ? 'border-blue-600 bg-blue-600' : null}
                                            ${location.pathname === '/CreateModelStep5' ? 'border-blue-600 bg-blue-600' : null}
                                            `}
                                ></div>                             
                        </div>
                {/* <div>his is actual location: {location.pathname}</div> */}
                {/* <div className="mb-5 container"> space between flex gap-10 stepper-item `${className}`*/}
//                 <div className="mb-5 flex gap-x-10  relative stepper-item">
//                     {/*{stepLabel.map((label) => {
//                         return(*/}
//                     <div className="items-center flex flex-col">
//                         <div className="text-center text-down ">Basic information</div>
//                         <div className={`border bg-white border-solid border-1 border-blue-700 rounded-full w-3 h-3 z-50 circle
//                                                 ${location.pathname === '/CreateModelStep1' || location.pathname === '/CreateModelStep2' ? 'border-blue-700' : 'bg-blue-600'}
//                                                 `}
//                         ></div>
//                     </div>
//                     <div className="items-center flex flex-col">
//                         <div className="text-center ">Bank statement analysis</div>
//                         <div className={`border bg-white border-solid border-1 rounded-full w-3 h-3 z-50 border-gray-400                            
//                                                 ${location.pathname === '/CreateModelStep3_0' ? 'border-blue-600' : null}
//                                                 ${location.pathname === '/CreateModelStep3' ? 'border-blue-600 bg-blue-600' : null}
//                                                 ${location.pathname === '/CreateModelStep4' ? 'border-blue-600 bg-blue-600' : null}
//                                                 ${location.pathname === '/CreateModelStep5' ? 'border-blue-600 bg-blue-600' : null}
//                                                 `}
//                         ></div>
//                     </div>

//                     <div className="items-center flex flex-col">
//                         <div className="text-center text-down circle">Credit report analysis</div>
//                         <div className={`border bg-white border-solid border-1 rounded-full w-3 h-3 z-50 border-gray-400
//                                                 ${location.pathname === '/CreateModelStep3' ? 'border-blue-600' : null}
//                                                 ${location.pathname === '/CreateModelStep4' ? 'border-blue-600 bg-blue-600' : null}
//                                                 ${location.pathname === '/CreateModelStep5' ? 'border-blue-600 bg-blue-600' : null}
//                                                 `}
//                         ></div>
//                     </div>

//                     <div className="items-center flex flex-col">
//                         <div className="text-center text-down">Wrap Up</div>
//                         <div className={`border bg-white border-solid border-1 border-gray-400 rounded-full w-3 h-3 z-50
//                                                 ${location.pathname === '/CreateModelStep4' ? 'border-blue-600' : null}
//                                                 ${location.pathname === '/CreateModelStep5' ? 'border-blue-600 bg-blue-600' : null}
//                                                 `}
//                         ></div>
//                     </div>

//                     <div className="items-center flex flex-col">
//                         <div className="text-center text-down circle">Preview and confirm"</div>
//                         <div className={`border bg-white border-solid border-1 border-gray-400 rounded-full w-3 h-3 z-50
//                                                 ${location.pathname === '/CreateModelStep5' ? 'border-blue-700' : null}
//                                                 `}
//                         ></div>
//                     </div>
//                     {/* )
//                     })}  */}

//                     {/* <ul className="progressbar"> 
//                         <li>Basic information</li>
//                         <li>Bank statement analysis</li>
//                         <li>Credit report analysis</li>
//                         <li>Wrap Up</li>
//                         <li>Preview and confirm</li>

//                     </ul> */}

//                 </div>
//                 <h1 className="xl:text-xl md:text-lg sm:text-base font-medium">{title}</h1>
//             </div>

//         </div>
//     )

// }

// export default CreateModelProgress;